function StandardAccounts() {
    return (
        <div>
            <h2>Standard Accounts</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default StandardAccounts;